import styled from "styled-components";

export const ProductInventoryViewWrapper = styled.div`
  width: 100%;
  padding: 2rem;

  @media screen and (max-width: ${({ theme }) => theme.screen.mobile}) {
    padding: 2rem 0.5rem;
  }

  .product-header {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 2rem;

    .brand {
      font-size: 1.6rem;
      font-weight: 600;
      color: ${({ theme }) => theme.text.primary};
    }
    .meta {
      color: ${({ theme }) => theme.text.muted_200};
      font-size: 1rem;
    }
  }

  // MED-681: mirrors the existing .pending status-pill palette used in the
  // shared Table component, so the two indicators for the same underlying
  // state read as one system rather than two different color languages.
  .approval-pending-banner {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: #ffa6001b;
    border: 1px solid #ffa60055;
    color: #a35b00;
    border-radius: 6px;
    padding: 0.75rem 1rem;
    margin-bottom: 1.5rem;
    font-size: 0.9rem;
  }

  .table-wrapper {
    width: 100%;
  }
`;
